export const baseEnvironment = {
  auth: {
    login: 'auth/client_login',
    signup: 'auth/signup',
    verify: 'auth/verify',
    resend: 'auth/resend',
    change_password:"admin/change_password",
    forgotpassword: 'auth/forgotpassword',
    refreshToken: 'auth/refreshToken',

  },
  client: {
    client: "client/client",
    relation: "client/relation",
    employer: "client/employer",
    employment: "client/client_employment",
    docs: "client/client_doc",
    profile: 'client/user_profile',
    beneficiary:'client/client_beneficiary',
    beneficiarylookup:'client/beneficiarylookup',
    dashboard:'client/dashboard_analytics'
  },
  products:{
    loan: {
      loan: "loan/loans",
      preview: "loan/schedule",
      loanlookup:"loan/myloanlookup",
      repayloan:"loan/repayment",
      online_payment:"loan/online_payment",
      confirm_online_payment:"loan/confirm_online_payment"
    },
    consumerfinance:{
      products:"consumerfinance/products",
      preview:"loan/cfschedule",
      loan:"loan/cfloan",
      cash:"consumerfinance/cashpayment"
    }
  },
  wallet: {
    mywallet: "wallet/my_wallet",
    dashboard: "wallet/my_dashboard",
    transfer:{
      wallet: "wallet/wallettransfer",
      momo: "wallet/momotransfer",
      bank: "wallet/banktransfer",
    },
    verifyAccountNumber:'wallet/verifyaccountnumber',
  },
  admin: {
    lookups: "admin/lookups",
  },
  payment:{
    onlinepayment:"payment/onlinepayment",
    checkstatus:"payment/onlinepayment/status",
    checkout:"payment/hubtel/checkout",
  }
};
